module.exports = __webpack_public_path__ + "media/team_photos/Anna-Schon-photo-b53ea6c1.webp";